import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { AiOutlineEye } from "react-icons/ai";
import { NEWS_TYPE } from '@/components/helpers/constant.js';
import { Link, Image, ScrollShadow } from "@nextui-org/react";

import LoadingCommon from "@/components/shared/loadingCommon";
import SharedServiceInstance from "@/services/shared-service";
import SharedService from "@/services/shared-service";
import TitleTemplate from "@/components/shared/title-template";

var _ = require('lodash');

export function ContainBlock({cateDetail}) {
    const sharedService = SharedServiceInstance;
    const firstCateDetail = _.head(cateDetail);
    const cateDetailMore = _.drop(cateDetail) || [];

    return <>
        <Link href={SharedService.getPostPath(firstCateDetail)} className="block w-full text-white text-md">
            <div className="w-full">
                <Image className="rounded-none" alt={firstCateDetail?.title}
                    src={sharedService.isValidUrl(firstCateDetail?.photo) ? sharedService.getOptimizeImage(firstCateDetail.photo, 'main-post-view') : "/assets/images/loi-chua.png"}
                />
            </div>

            <p className="flex items-center font-bold bg-primary">
                    <p className="line-clamp-3 px-2 py-1 text-center">
                        {firstCateDetail?.title}
                    </p>
            </p>
        </Link>

        <div className="divide-y-1 px-1 bg-white">
            <ScrollShadow hideScrollBar className="h-[250px]">
                {cateDetail && cateDetailMore.map((item, index) => {
                    return <>
                        <div className="flex gap-1 px-2" key={index}>
                            <Link href={SharedService.getPostPath(item)} className="w-full">
                                <p className="w-10/12 truncate text-news text-sm font-semibold py-2">{item.title}</p>
                                <p className="pl-2 pr-1"><AiOutlineEye className="text-gray-400"/></p>
                                <p className="text-news">{sharedService.convertUnit(item.visit) || 0}</p>
                            </Link>
                        </div>
                    </>;
                })}
            </ScrollShadow>
        </div>
    </>
}

function EmptyBlock({cateName}) {
    return <>
        <LoadingCommon itemName={cateName} />
    </>
}

export default function CommonNews(data, postId) {
    const router = useRouter();
    const cateStaticObj = _.find(NEWS_TYPE, item => item.code === data.detailCode);
    const cateName = cateStaticObj?.name;
    const [mostViewDetail, setMostViewDetail] = useState(null);

    let params = '&status=latest';
    let reqCateCode = cateStaticObj?.link || cateStaticObj.code;

    const fetchMostViewData = async () => {
        let url = '/api/posts?cid=' + reqCateCode + params;
        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                setMostViewDetail(data);
            })
    };

    useEffect(() => {
        if (postId || data?.isMoreBlock) {
            fetchMostViewData();
        }
    }, [postId]);

    return <>
        <div className="">
            {mostViewDetail?.total === 0 && <>
                <EmptyBlock cateName={cateName}/>
            </>}

            {mostViewDetail?.total > 0 && <>
                <ContainBlock cateDetail={mostViewDetail.value} />
            </>}
        </div>
    </>
}
